/* eslint-disable camelcase */
export var KeyEncryptionAlgorithm;
(function (KeyEncryptionAlgorithm) {
    KeyEncryptionAlgorithm["Rsa1_5"] = "http://www.w3.org/2001/04/xmlenc#rsa-1_5";
    KeyEncryptionAlgorithm["Rsa_oaep_mgf1p"] = "http://www.w3.org/2001/04/xmlenc#rsa-oaep-mgf1p";
})(KeyEncryptionAlgorithm || (KeyEncryptionAlgorithm = {}));
//# sourceMappingURL=key-encryption-algorithm.js.map